import { createI18n } from 'vue-i18n';
import en from '@/TranslatorJson/en.json'
import spanish from '@/TranslatorJson/spanish.json'
import dynamicUiText from '@/helpers/dynamicUiText'
import { terminologyRevision } from '@/helpers/terminologyReactive'

function localmeassge() {
    const locales = [{ en: en }, { spanish: spanish }]
    const message = {}
    locales.forEach(lang => {
        const key = Object.keys(lang)
        message[key]=lang[key]
    })
    return message
}

const i18n = createI18n({
    legacy: false,
    locale: localStorage.getItem("Language"),
    fallbackLocale: localStorage.getItem("Language"),
    messages:localmeassge()
})

const originalTranslate = i18n.global.t.bind(i18n.global)
i18n.global.t = (...args) => {
  void terminologyRevision.value
    const key = typeof args[0] === 'string' ? args[0] : null
    const result = originalTranslate(...args)
    if (typeof result === 'string' && !dynamicUiText.isUntranslatedI18nKey(result, key)) {
        return dynamicUiText.applyDynamicTerminology(result)
    }
    return result
}

export default i18n